import './App.css';
import { IndexRoutes } from './routes/IndexRoutes';

function App() {
  return (
    <IndexRoutes/>
  );
}

export default App;
